"use client";
import { useContext } from "react";
import { useStore } from "zustand";
import { ProductsContext } from "./Provider";
import { ProductsProps } from "@/store/modules/products";

export function useProductsContext<T>(
    selector: (state: ProductsProps) => T,
): T {
    const store = useContext(ProductsContext);
    if (!store)
        throw new Error("Missing PageProductsContext.Provider in the tree");
    return useStore(store, selector);
}

export { ProductsProvider } from "./Provider";
